import React from 'react';
import { Add } from '../../components/svgs';
import appState from '../../state/AppStateContainer';
import BtButton from '../bt-button/bt-button';
import { ServiceDownload } from '../../services/service-download';
import ExcelIcon from '../../assets/images/excel.png';
import Tabs from '../../components/shared/Tabs';
import NotificationCounter from '../../components/shared/NotificationCounter/NotificationCounter';
import { TabNames } from './supplier-database';
import { useTranslation } from 'react-i18next';

const TableTopActions = ({ onAddArea, onAddSupplier, isReadOnlyUser, selectedTab, onTabChange, onRecategorizeSuppliers, numberOfRecommendedSuppliers, selectMode, inboxCount, onShowSupplierApplicationInfo, isFeaturedSupplier, selectedTabName }) => {
  const [t] = useTranslation('supplierDatabase', { keyPrefix: 'tableTopActions' });
  const tabs = [t('tabs.supplierDatabase', 'Leverantörsdatabas')];
  if (!selectMode) {
    tabs.push(<span style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>{t('tabs.applications', 'Ansökningar')} <NotificationCounter style={{ backgroundColor: 'var(--gray-200)', color: 'var(--gray-800)' }} counter={inboxCount} /></span>);
    tabs.push(('tabs.rejectedApplications', 'Nekade ansökningar'));

    if (isFeaturedSupplier) {
      tabs.push(('tabs.featuredSupplier', 'Utvald leverantör'));
    }

    if (appState.isSuperAdminOrg()) {
      tabs.push(('tabs.adApplications', 'Annonsansökningar'));
    }
  }
  if (selectMode && numberOfRecommendedSuppliers > 0) {
    tabs.push(<span style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>{t('tabs.recommendedSuppliers', 'Rekommenderade leverantörer')} <NotificationCounter style={{ backgroundColor: 'var(--gray-200)', color: 'var(--gray-800)' }} counter={numberOfRecommendedSuppliers} /></span>);
  }

  return (
    <div className="sp-top-actions">
      <div className="tab-container">
        <Tabs tabs={tabs} selected={selectedTab} onChange={onTabChange} style={{ marginBottom: '20px' }} />
        {!isReadOnlyUser && (
          <div className="sp-btn-group">
            {appState.isManagementRole() && selectedTabName !== TabNames.AD_APPLICATIONS && (
              <BtButton
                class="white"
                onClick={async () => { await ServiceDownload.downloadSupplierExcelFile(); }}
                leftIcon={<img className="excel-icon--style" src={ExcelIcon} width="25px" height="25px" />}
                style={{ border: '1px solid var(--gray-300)' }}
              >
                {t('button.export', 'Exportera leverantörer')}
              </BtButton>
            )}

            {onAddArea && selectedTabName !== TabNames.AD_APPLICATIONS && appState.isAdminRole() && (
              <BtButton class='white' onClick={onAddArea}>
                <Add fill="var(--orange-500)" />
                <span>{t('button.addArea', 'Lägg till yrkeskategori')}</span>
              </BtButton>
            )}

            {onAddSupplier && (selectMode || selectedTab != 1) && selectedTabName !== TabNames.AD_APPLICATIONS && (
              <BtButton onClick={onAddSupplier}>
                <Add />
                <span>{t('button.addSupplier', 'Lägg till leverantör')}</span>
              </BtButton>
            )}

            {onShowSupplierApplicationInfo && (!selectMode && selectedTab == 1) && (
              <BtButton class='white' onClick={onShowSupplierApplicationInfo}>{t('button.applicationInfo', 'Ansökningsformulär')}</BtButton>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default TableTopActions;
